module.exports = __webpack_public_path__ + "static/media/icon-shar-doct.95a8ae1c.svg";